import { Map } from 'immutable';
import { actionTypes as actionTypes } from '../../../actions/Administration/MatSettingsPage/Dialogs/createGroupTypeDialogActions';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: []
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case actionTypes.CREATE_GROUP_TYPE_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case actionTypes.CREATE_GROUP_TYPE_DIALOG_HIDE:
      return Map(defaultState);

    case actionTypes.CREATE_GROUP_TYPE_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case actionTypes.CREATE_GROUP_TYPE_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case actionTypes.CREATE_GROUP_TYPE_DIALOG_FETCH_DIALOG_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







